import { render, staticRenderFns } from "./right-remark.vue?vue&type=template&id=b647e228&scoped=true&"
import script from "./right-remark.vue?vue&type=script&lang=js&"
export * from "./right-remark.vue?vue&type=script&lang=js&"
import style0 from "./right-remark.vue?vue&type=style&index=0&id=b647e228&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b647e228",
  null
  
)

export default component.exports